// i18n 国际化，记录【当前语言】和【切换语言 function】的全局上下文
// 如果未来使用了类 redux 的全局状态管理器来管理，可以对这里进行改造，不使用 context 来处理，统一用一种方案

'use client';

import { createContext, useContext, useMemo, useState } from 'react';

import { getQueryValue } from '@/utils/url-utils';

import { type TLocals, Locales } from './config';

interface ILocaleContextType {
    locale: TLocals;
    setLocale: (locale: TLocals) => void;
}

const LocaleContext = createContext<ILocaleContextType>({
    locale: Locales.en, // 当前语言
    setLocale: () => {}, // 切换语言的函数
});

export function LocaleProvider({ children }: { children: React.ReactNode }) {
    const _lang = (getQueryValue('_lang') as TLocals | null) || Locales.en;

    // 设置当前语言的 state 默认为en
    const [locale, setLocale] = useState<TLocals>(_lang);

    const contextValue = useMemo(
        () => ({
            locale,
            setLocale,
        }),
        [locale]
    );

    return <LocaleContext.Provider value={contextValue}>{children}</LocaleContext.Provider>;
}

export function useLocaleContext() {
    const context = useContext(LocaleContext);
    if (!context) {
        throw new Error('useLocaleContext must be used within a LocaleProvider');
    }
    return context;
}
